// extracted by mini-css-extract-plugin
export default {"primaryColor":"#121e59"};